
import HeroService from '../../components/HeroComponents/HeroService'
import Testimonial from "../../components/Testimonial";
import Newletter from "../../components/Newletter";
import Service from "../../components/Service";

function ServicePage() {
  return (
    <>
   <HeroService/>

   <Service/>

   <Newletter/>

   <Testimonial/>


    </>
  )
}

export default ServicePage